module.exports = __webpack_public_path__ + "assets/img/logo.6219749c.svg";